"use client";

import { Button } from "@/components/ui/button";
import { Slide } from "@/components/ui/slide";
import Slide1 from "@/images/slide-images/slide1.jpg";
import Slide2 from "@/images/slide-images/slide2.jpg";
import Slide3 from "@/images/slide-images/slide3.jpg";
import Slide4 from "@/images/slide-images/slide4.jpg";
import Slide5 from "@/images/slide-images/slide5.jpg";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { useRef, useState } from "react";

const slidesData = [
  {
    header: "Safe & Indexed Storage",
    text: "Keep your slides organized and pristine with secure compartments designed for long-term preservation.",
    image: Slide1,
  },
  {
    header: "Removable Aluminum Trays",
    text: "Retrieve slides effortlessly with sturdy, interchangeable trays, numbered for easy indexing.",
    image: Slide2,
  },
  {
    header: "Unmatched Durability",
    text: "Seasoned hardwood construction ensures your storage solution lasts for years.",
    image: Slide4,
  },
  {
    header: "Proudly American-Made",
    text: "Designed and crafted in the USA with exceptional quality and care.",
    image: Slide5,
  },
  {
    header: "Flexible Storage Systems",
    text: "Choose between stackable unit systems or larger cabinet systems to fit your lab’s needs.",
    image: Slide3,
  },
];

export default function SlidesCarousel() {
  // const [slides, setSlides] = useState(slidesData);
  const currentSlideRef = useRef<HTMLLIElement>(null);
  const lastSlideRef = useRef<HTMLLIElement>(null);

  const [cards, setCards] = useState(slidesData);

  const prevSlide = () => {
    if (cards[0]) {
      setCards(cards.slice(1).concat(cards[0]));
    }
  };

  const nextSlide = () => {
    if (cards.length > 0) {
      setCards([cards[cards.length - 1] as (typeof cards)[number]].concat(cards.slice(0, -1)));
    }
  };

  return (
    <>
      <div className="slide-stack h-[300px] w-full max-w-[950px] md:h-[400px]">
        <ul className="slide-list relative">
          {cards.map((slide, index) => {
            const isTop = index === cards.length - 1;
            const isBottom = index === 0;
            return (
              <Slide
                key={slide.header}
                ref={isTop ? currentSlideRef : isBottom ? lastSlideRef : null}
                header={slide.header}
                text={slide.text}
                image={slide.image}
              />
            );
          })}
        </ul>
      </div>

      <div className="-mt-10 flex gap-5">
        <Button onClick={prevSlide} size="icon" className="size-12">
          <ChevronLeftIcon className="size-6" />
        </Button>
        <Button onClick={nextSlide} size="icon" className="size-12">
          <ChevronRightIcon className="size-6" />
        </Button>
      </div>
    </>
  );
}
